import React from 'react';

const SportsConsentBanner = React.memo(({ showConsentBanner, onDecline, onAccept }) => {
  if (!showConsentBanner) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 bg-gray-900 text-white p-4 z-50 shadow-2xl">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between space-y-3 sm:space-y-0 sm:space-x-4">
          <div className="flex-1">
            <p className="text-sm sm:text-base">
              🍪 We use functional cookies for game progress tracking and anonymized analytics.
              We only use tracking cookies to personalize ads after explicit permission from EU users.
            </p>
          </div>
          <div className="flex space-x-3 whitespace-nowrap">
            <button
              onClick={onDecline}
              className="px-4 py-2 bg-gray-600 hover:bg-gray-700 rounded-lg text-sm font-medium transition-colors duration-300"
            >
              Decline
            </button>
            <button
              onClick={onAccept}
              className="px-4 py-2 bg-blue-600 hover:bg-blue-700 rounded-lg text-sm font-medium transition-colors duration-300"
            >
              Accept All
            </button>
          </div>
        </div>
      </div>
    </div>
  );
});

export default SportsConsentBanner;
